import {
  CancelAppointmentRequest,
  UpdateAppointmentRequest,
} from "./appointment.mapper";

import { DASHBOARD } from "../dashboard/dashboard.query";
import { DETAIL_APPOINTMENT } from "../appointment-detail/appointment-detail.query";
import { FindAvailabilityFormType } from "../available-times/available-times.schema";
import { GET_APPOINTMENTS } from "../appointment-list/appointment-list.query";
import { IAppointmentItemResponse } from "../appointment-list/appointment-list.interface";
import { IUpdateAppointmentRequest } from "./appointment.interface";
import { ReasonForCancelFormType } from "../reason-for-cancel/reason-for-cancel.schema";
import { UPDATE_APPOINTMENT } from "./appointment.mutation";
import { toastMessageActions } from "../../state/request";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { IAppointmentCreateResponse } from "../create-appointment-v2/create-appointment-v2.interface";

export const useUpdateAppointment = () => {
  const dispatch = useDispatch();
  const { selectedVisit: visitSelected } =useAppointmentStore();
  const [
    update, { data, loading },
  ] = useMutation<{ updateAppointment: IAppointmentCreateResponse }>(UPDATE_APPOINTMENT);

  const updateAppointment = (findAvailabilityForm: FindAvailabilityFormType) => {
    const appointmentRequest: IUpdateAppointmentRequest = new UpdateAppointmentRequest(
      findAvailabilityForm,
      visitSelected as unknown as IAppointmentItemResponse,
    );

    update({
      variables: { data: appointmentRequest },
      refetchQueries: [
        { query: GET_APPOINTMENTS },
        { query: DASHBOARD },
        { query: DETAIL_APPOINTMENT, variables: { id: visitSelected?.id } },
      ],
    });
  };

  const cancelAppointment = (reasonForCancelForm: ReasonForCancelFormType) => {
    const appointmentRequest: IUpdateAppointmentRequest = new CancelAppointmentRequest(
      reasonForCancelForm,
      visitSelected as unknown as IAppointmentItemResponse,
    );

    update({
      variables: { data: appointmentRequest },
      refetchQueries: [
        { query: GET_APPOINTMENTS },
        { query: DASHBOARD },
      ],
    });
  };

  useEffect(() => {
    dispatch(toastMessageActions.setGlobalLoading(loading));
  }, [loading]);

  return {
    updateAppointment,
    cancelAppointment,
    appointment: data?.updateAppointment,
  };
};
